module.exports = __webpack_public_path__ + "static/img/02_zx.be9c8a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/secondLine/02_zx.png
// module id = m2Bf
// module chunks = 0